import { SET_FLOW_STEP } from './constants';

export const setFlowStep = (stateId: string, stepId: string, stepIndex: number) => ({
  type: SET_FLOW_STEP,
  stateId,
  stepId,
  stepIndex,
});
